import { Component, Input, ViewChild, NgZone, OnInit,EventEmitter,Output  } from '@angular/core';

import { ApiResource } from '../../resources/api.resource';
declare var $: any;

@Component({
  selector: 'footer-component',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input('FooterHtml') FooterHtml;
  @Input('menuFooterHtml') menuFooterHtml;
  @Input('formulario') formData;

  @Output() uuid: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    console.log("FooterHtml--->"+this.FooterHtml);
    console.log("Footer readlocal--->"+this.readLocalStorageValue('idiomaEspañol'));
  }


 

readLocalStorageValue(key) {
    return localStorage.getItem(key);
}

  redireccionarAPaginaExistente(uuid) {

    this.uuid.emit(uuid);
   

    //ga('send', { 'hitType': 'pageview', 'page': '/contact-us/submitted/', 'title': 'Contact Us Submitted' });


        // gtag('config', 'UA-174017197-1',{
        // 'page' : '/personas/'+uuid, 
        // 'page-path':'/personas/'+uuid,
        // 'page_title' : '/personas/'+uuid,
        // 'page_location' : '/personas/'+uuid
        // });


    // $(".lg-menu").fadeOut();
    // // $("#lg_slide").fadeOut();
    // $("#lg_slide").removeClass("active");
  }



}
